import { useEffect, useRef, useState } from "react";
import RFB from "@novnc/novnc";
import { t } from "../../i18n";
import { api } from "../../api";
import type { DevelopmentSelection } from "../chat/ChatDevelopmentPanel.types";
import { selectionBody } from "../chat/ChatDevelopmentPanel.types";

export function PreviewTab({
  conversationId,
  selection,
}: {
  conversationId: string;
  selection: DevelopmentSelection;
}) {
  const host = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState(t("Starting Flutter Linux preview…"));
  const [error, setError] = useState("");

  useEffect(() => {
    if (!host.current) return;
    let disposed = false;
    let rfb: RFB | undefined;
    void api<{ ticket: string }>(
      `/conversations/${conversationId}/development-workspace/preview-ticket`,
      { method: "POST", body: JSON.stringify(selectionBody(selection)) },
    )
      .then(({ ticket }) => {
        if (disposed || !host.current) return;
        const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
        rfb = new RFB(
          host.current,
          `${protocol}//${window.location.host}/api/development-preview?ticket=${encodeURIComponent(ticket)}`,
        );
        rfb.scaleViewport = true;
        rfb.resizeSession = false;
        rfb.viewOnly = false;
        rfb.addEventListener("connect", () =>
          setStatus(t("Preview connected")),
        );
        rfb.addEventListener("disconnect", () => {
          if (!disposed) setStatus(t("Preview disconnected"));
        });
        rfb.addEventListener("securityfailure", (event) => {
          if (!disposed) {
            const detail = (event as CustomEvent<{ status?: string }>).detail;
            setError(
              detail?.status || t("Preview security negotiation failed"),
            );
          }
        });
      })
      .catch((reason) => {
        if (disposed) return;
        setError(
          reason instanceof Error ? reason.message : t("Preview unavailable"),
        );
      });
    return () => {
      disposed = true;
      rfb?.disconnect();
    };
  }, [conversationId, selection]);

  return (
    <div className="flex h-full min-h-0 flex-col bg-[#0c0f0e]">
      <div className="flex shrink-0 items-center justify-between border-b border-white/10 px-3 py-2 text-[11px] text-stone-300">
        <span>{error || status}</span>
        <span>{t("Flutter Linux")}</span>
      </div>
      <div ref={host} className="min-h-0 flex-1 overflow-hidden" />
    </div>
  );
}
